(function () {
  const searchSelector = '.admins-section .admin-search';

  const adminsSection = function () {
    let activeSection = null;

    const fullName = (admin) => [admin.first_name, admin.last_name].filter(Boolean).join(' ');

    const initials = (admin) => {
      return [admin.first_name, admin.last_name]
        .map((name) => (name || '').charAt(0))
        .join('')
        .toUpperCase();
    };

    const formatPhone = (phone) => {
      if (!phone) return '';

      const digits = String(phone).replace(/\D/g, '');
      const local = digits.length === 11 && digits[0] === '1' ? digits.slice(1) : digits;
      if (local.length !== 10) return phone;

      return `+1 (${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(6)}`;
    };

    const contact = (admin) => [admin.email, formatPhone(admin.phone)].filter(Boolean).join(' · ');

    const upsertOption = ($section, admin) => {
      const $select = $section.find('.admins-section-select');
      let $option = $select.find(`option[value="${admin.id}"]`);

      if ($option.length === 0) {
        $option = $('<option>').val(admin.id);
        $select.append($option);
      }

      $option.text(fullName(admin)).prop('selected', true);
      $select.trigger('change');
    };

    const upsertRow = ($section, admin) => {
      let $row = $section.find(`.admin-row[data-user-id="${admin.id}"]`).not('.admin-row-template');

      if ($row.length === 0) {
        const $template = $section.find('.admin-row-template');
        $row = $template.clone().removeClass('admin-row-template d-none').addClass('d-flex align-items-center');
        $row.attr('data-user-id', admin.id).data('user-id', admin.id);

        const $edit = $row.find('.admin-edit');
        if ($edit.length > 0) {
          $edit.attr('href', $edit.attr('href').replace('__ID__', admin.id));
        }

        $template.before($row);
      }

      $row.find('.admin-initials').text(initials(admin));
      $row.find('.admin-name').text(fullName(admin));
      $row.find('.admin-contact').text(contact(admin));
    };

    const upsertAdmin = (admin) => {
      if (!activeSection || activeSection.length === 0) return;

      upsertOption(activeSection, admin);
      upsertRow(activeSection, admin);
    };

    const hasActiveSection = () => activeSection !== null && activeSection.length > 0;

    const buildRemoveMessage = (message, name) => {
      const parts = String(message).split('{{name}}');
      const $message = $('<p>').addClass('mb-0');

      $message.append(document.createTextNode(parts[0]));
      $message.append($('<strong>').text(name));
      $message.append(document.createTextNode(parts[1] || ''));

      return $message[0];
    };

    const removeAdmin = ($section, $row, id) => {
      const $select = $section.find('.admins-section-select');

      $select.find(`option[value="${id}"]`).remove();
      $select.trigger('change');
      $row.remove();
    };

    $(document).on('click', '.admins-section .admin-add-toggle', function () {
      $(this).closest('.admins-section').find('.admin-add-panel').toggleClass('d-none');
    });

    $(document).on('change', searchSelector, function () {
      const selected = $(this).select2('data')[0];
      if (!selected || !selected.id) return;

      activeSection = $(this).closest('.admins-section');
      upsertAdmin(selected);
      activeSection = null;

      $(this).val(null).trigger('change');
      $(this).closest('.admin-add-panel').addClass('d-none');
    });

    $(document).on('click', '.admins-section .admin-new-user, .admins-section .admin-edit', function () {
      activeSection = $(this).closest('.admins-section');
    });

    $(document).on('hidden.bs.modal', '#modal', () => {
      activeSection = null;
    });

    $(document).on('click', '.admins-section .admin-remove', function () {
      const $row = $(this).closest('.admin-row');
      const $section = $row.closest('.admins-section');
      const id = $row.data('user-id');

      window.swalConfirm
        .fire({
          title: 'Remove administrator',
          html: buildRemoveMessage($section.data('remove-message'), $row.find('.admin-name').text()),
          confirmButtonText: 'Yes',
          cancelButtonText: 'Cancel',
        })
        .then((result) => {
          if (!result.value) return;

          removeAdmin($section, $row, id);
        });
    });

    $(document).on('turbolinks:load', () => {
      if ($(searchSelector).length > 0) {
        window.select2Ajax.bindselect2Ajax(searchSelector);
      }
    });

    return { upsertAdmin, hasActiveSection };
  };

  if (typeof window !== 'undefined') {
    window.adminsSection = adminsSection();
  }
})();
